import { ComponentProps, FC } from "react";
import { ThemedDropdown } from "@/App/components/themed/Dropdown";
import { MemberEligibilityMember } from "@/App/types";

export interface DependentRecord {
  member: {
    person_code: string;
    first_name: string;
    last_name: string;
    is_minor_dependent?: boolean;
  };
}

export interface DependentDropdownProps extends Omit<ComponentProps<typeof ThemedDropdown>, "children"> {
  /** the pre-filtered list of minor dependents */
  dependents: DependentRecord[];
  /** current primary member user's details */
  member: MemberEligibilityMember;
  /** maximum width for the wrapper div */
  maxWidth?: string | number;
}

/**
 * Dropdown component that displays the current member plus any minor dependents.
 * Expects minorDependents to be pre-filtered by parent component.
 */
export const DependentDropdown: FC<DependentDropdownProps> = ({
  dependents,
  member,
  maxWidth = "300px",
  ...dropdownProps
}) => {
  if (dependents.length === 0) {
    return null;
  }

  return (
    <div style={{ maxWidth }}>
      <ThemedDropdown
        {...dropdownProps}
      >
        <ThemedDropdown.Option value={member.person_code} key={member.person_code}>
          {member.first_name} {member.last_name}
        </ThemedDropdown.Option>
        {dependents.map((dependent) => (
          <ThemedDropdown.Option
            value={dependent.member.person_code}
            key={dependent.member.person_code}
          >
            {dependent.member.first_name} {dependent.member.last_name}
          </ThemedDropdown.Option>
        ))}
      </ThemedDropdown>
    </div>
  );
};
